import { Map } from 'immutable';

import * as constants from './../constants';
import {
  AppUploadingRecord,
} from './../records';

const initialState = Map({
  itemsUploading: Map(),
});

const appStorageReducer = (state = initialState, { type, payload, meta }) => {
  switch (type) {
    case constants.APP_STORAGE_UPLOAD_APP.REQUEST: {
      const displayName = payload.name.trim();

      return state.setIn(
        ['itemsUploading', meta.uploadAppId],
        new AppUploadingRecord({
          id: meta.uploadAppId,
          displayName,
        }),
      );
    }
    case constants.APP_STORAGE_UPLOAD_APP.PROGRESS: {
      return state.mergeIn(['itemsUploading', meta.uploadAppId], {
        progress: payload,
        status: constants.APP_UPLOAD_STATUS.UPLOADING,
      });
    }
    case constants.APP_STORAGE_UPLOAD_APP.SUCCESS: {
      return state.setIn(
        ['itemsUploading', meta.uploadAppId, 'status'],
        constants.APP_UPLOAD_STATUS.UPLOADED,
      );
    }
    case constants.APP_STORAGE_UPLOAD_APP.FAILURE: {
      return state.mergeIn(['itemsUploading', meta.uploadAppId], {
        error: constants.APP_UPLOAD_ERROR_MESSAGE,
        status: constants.APP_UPLOAD_STATUS.FAILED,
      });
    }
    case constants.APP_STORAGE_UPLOAD_APP.CANCEL: {
      return state.mergeIn(['itemsUploading', meta.uploadAppId], {
        progress: 0,
        status: constants.APP_UPLOAD_STATUS.CANCELED,
      });
    }

    default:
      return state;
  }
};

export default appStorageReducer;
export { initialState };
